var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "complaint-record-page" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.list.length
        ? _c(
            "section",
            { staticClass: "record-list" },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "article",
                {
                  key: index,
                  staticClass: "record-item",
                  on: {
                    click: function($event) {
                      return _vm.handleItemClick(item)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "item-head" }, [
                    _c("div", { staticClass: "text-1" }, [
                      _vm._v(_vm._s(item.create_time))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "right",
                        class: item.result ? "done" : "pending"
                      },
                      [_vm._v(_vm._s(item.result ? "已处理" : "处理中"))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-2" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("联系人：")
                    ]),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(item.name || "--"))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-2" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("联系电话：")
                    ]),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(item.mobile || "--"))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-2 desc-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("问题：")
                    ]),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(item.desc || "--"))
                    ])
                  ])
                ]
              )
            }),
            0
          )
        : _c("section", { staticClass: "empty" }, [
            _c("img", {
              staticClass: "empty-illust",
              attrs: {
                src: require("./static/images/complaint-record/Frame.png"),
                alt: "",
                "aria-hidden": "true"
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("暂无记录～～")])
          ]),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: {
            showConfirmButton: false,
            width: "88%",
            closeOnClickOverlay: true
          },
          model: {
            value: _vm.modal,
            callback: function($$v) {
              _vm.modal = $$v
            },
            expression: "modal"
          }
        },
        [
          _c("div", { staticClass: "detail-dialog" }, [
            _c("div", { staticClass: "detail-line" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("投诉时间：")]),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.one.create_time || "--"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-line" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("联系人：")]),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.one.name || "--"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-line" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("联系电话：")]),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.one.mobile || "--"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-line detail-desc" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("问题详情：")]),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.one.desc || "--"))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "detail-line detail-files" },
              [
                _c("span", [_vm._v("附件：")]),
                _vm._v(" "),
                _vm._l(_vm.one.files, function(img, index) {
                  return _c("img", {
                    key: index,
                    staticClass: "detail-file-img",
                    attrs: { src: img },
                    on: {
                      click: function($event) {
                        return _vm.showImg(img)
                      }
                    }
                  })
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "detail-line detail-desc" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("处理结果：")]),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.one.result || "暂未处理"))
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "head" }, [
      _c("div", { staticClass: "head-glow" }),
      _vm._v(" "),
      _c("h1", [_vm._v("投诉记录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ececfdb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ececfdb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newpage/tousujilu.vue
// module id = null
// module chunks = 